import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  Button,
  Row,
  Col,
  Typography,
  Form,
  Input,
  message,
} from "antd";
import authService from "../../services/authService";
import { useUser } from "../../contexts/UserContext";
import { LoginCredentials } from "../../types/auth";
import profileService from "../../services/profileService";

const { Title } = Typography;
const { Footer, Content } = Layout;

const SignIn = () => {
  const navigate = useNavigate();
  const { setUser } = useUser();
  const [isLoading, setIsLoading] = React.useState(false);


  const onFinish = async (values: LoginCredentials) => {
    try {
      setIsLoading(true);
      
      await authService.login(values);
      
      const userData = await profileService.getMe();
      setUser(userData);

      message.success("Đăng nhập thành công");
      navigate("/jobs-management");
    } catch (error: any) {
      console.error("Login error:", error);
      message.error("Email hoặc mật khẩu không chính xác");
    } finally {
      setIsLoading(false);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Form validation failed:", errorInfo);
  };

  return (
    <>
      <Layout className="layout-default layout-signin">
        <Content className="signin">
          <Row gutter={[24, 0]} justify="space-around">
            <Col>
              <h1 className="text-center logo logo-lg">Nebecom</h1>
              <div className="signin-form">
                <Title className="mb-15 text-center">Đăng nhập</Title>
                
                <Form
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  layout="vertical"
                  className="row-col"
                >
                  <Form.Item
                    className="username"
                    label="Email"
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Email không được để trống",
                      },
                      {
                        type: "email",
                        message: "Email không hợp lệ",
                      },
                    ]}
                  >
                    <Input 
                      placeholder="Email" 
                      autoComplete="email"
                    />
                  </Form.Item>

                  <Form.Item
                    className="username"
                    label="Mật khẩu"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Mật khẩu không được để trống",
                      },
                    ]}
                  >
                    <Input.Password 
                      placeholder="Mật khẩu" 
                      autoComplete="current-password"
                    />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={isLoading}
                      style={{ width: "100%" }}
                    >
                      ĐĂNG NHẬP
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </Col>
          </Row>
        </Content>
        <Footer>
          <p className="copyright">
            © 2025 Nebecom - Empowering eCommerce Brands
          </p>
        </Footer>
      </Layout>
    </>
  );
};

export default SignIn;
